import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Home from "./Home";
import CheckDeadline from './CheckDeadline';
import HomeworkHistory from './HomeworkHistory';
import UpcomingEvents from './UpcomingEvents';
import { LanguageProvider } from './contexts/LanguageContext';

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <div className="flex flex-col min-h-screen">
          <Routes>
            <Route path="/" element={<Home/>} />
            <Route path="/deadline" element={<CheckDeadline />} />
            <Route path="/history" element={<HomeworkHistory />} />
            <Route path="/upcoming" element={<UpcomingEvents />} />
          </Routes>
        </div>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
